import styled from "styled-components";

export const DoktoranturaWrapper = styled.div`
  
`